// Copyright (c) Ensho Health, 2021 to present

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import logo from '../../static/img/accelerate-transparent.png';

import {
  StyledLink,
  StyledSubmitButton,
  StyledInstructions,
  StyledError,
  StyledInput,
  StyledForm,
  StyledTitle
} from './FormWelcome.styles.js';

const FormResetPassword = (props) => {
  const [fields, setFields] = useState({
    password: '',
    confirm: ''
  });

  const onFieldChange = (event) => {
    const field = event.target.name;
    setFields({ ...fields, [field]: event.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (
      fields.password &&
      fields.confirm &&
      fields.password === fields.confirm
    ) {
      props.onSubmit(fields);
    }
  };
  const isFormDisabled = !fields.password || !fields.confirm || props.disabled;

  return (
    <StyledForm onSubmit={onSubmit}>
      <img width="220" src={logo} alt="Compass Logo" />
      <StyledTitle>Welcome to the Ensho Health Platform</StyledTitle>
      <StyledInstructions>
        Please follow the instructions below to activate your account
        <br />
        <br />
        Your password must:
        <ul>
          <li>Have at least 8 characters</li>
          <li>Have at least one lower case letter</li>
          <li>Have at least one upper case letter</li>
          <li>Have at least one number</li>
          <li>Have at least one symbol</li>
          <li>Not contain parts of your username or email address</li>
          <li>Not have been any of your last four passwords</li>
        </ul>
      </StyledInstructions>

      <StyledInput
        onChange={onFieldChange}
        defaultValue={fields.email}
        large
        type="password"
        name="password"
        placeholder="Enter Password"
        intent={props.errorMessage ? 'danger' : ''}
      />

      <StyledInput
        onChange={onFieldChange}
        defaultValue={fields.email}
        large
        type="password"
        name="confirm"
        placeholder="Repeat Password"
        intent={props.errorMessage ? 'danger' : ''}
      />

      {props.errorMessage && <StyledError>{props.errorMessage}</StyledError>}
      <StyledSubmitButton
        loading={props.loading}
        disabled={isFormDisabled}
        type="submit"
        intent="default"
      >
        Next
      </StyledSubmitButton>

      <StyledLink onClick={props.onBack}>Back</StyledLink>
    </StyledForm>
  );
};

FormResetPassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  errorMessage: PropTypes.string
};

FormResetPassword.defaultProps = {
  loading: false,
  errorMessage: null
};

export default FormResetPassword;
